import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInvoice = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M15 21v-3H0v1.5A4.5 4.5 0 0 0 4.5 24h11.334c-.516-.887-.834-1.902-.834-3"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M6 0v15h12v6a3 3 0 1 0 6 0V0zm15 12H9V9h12zm0-6H9V3h12z"
	})]
});
const ForwardRef = forwardRef(SvgInvoice);
export default ForwardRef;
